export default function(h, row, index) {
    let x = '#/task/'+row.id;
    if (row.type_id)
        if (row.subject && row.subject!==null)
            return <span>{row.type.title}<br/><a href={x}>{row.subject}</a></span>
        else
            return <span><a href={x}>{row.type.title}</a></span>
    else
        if (row.subject && row.subject!==null)
            return <span><a href={x}>{row.subject}</a></span>
        else
            return <span><a href={x}>заголовок задачи не указан</a></span>
}